const milestones = [
  {
    year: '2022',
    title: 'Foundation Established',
    desc: 'IKIRU – The Epilepsy Foundation is officially registered in Nigeria, born from a passionate vision to transform epilepsy care across Africa.',
    icon: 'ri-flag-line',
  },
  {
    year: '2023',
    title: 'First Community Outreach',
    desc: 'Launched our inaugural community awareness drives in Lagos and Abuja, reaching over 5,000 individuals with accurate epilepsy education and seizure first-aid training.',
    icon: 'ri-community-line',
  },
  {
    year: '2023',
    title: 'Support Groups Launched',
    desc: 'Established the first 3 community-based epilepsy support groups, providing safe spaces for patients, caregivers, and families to connect and heal.',
    icon: 'ri-team-line',
  },
  {
    year: '2024',
    title: 'Medical Partnerships Forged',
    desc: 'Signed formal partnerships with leading hospitals and healthcare institutions to deliver specialized epilepsy training and annual medical outreaches.',
    icon: 'ri-hospital-line',
  },
  {
    year: '2024',
    title: 'Policy Advocacy Begins',
    desc: 'Published our first epilepsy whitepaper and engaged government stakeholders, laying the groundwork for a national epilepsy policy framework.',
    icon: 'ri-government-line',
  },
  {
    year: '2025',
    title: 'Pan-African Expansion',
    desc: 'Scaling our programs beyond Nigeria, building strategic alliances across West Africa to amplify our impact and reach more communities.',
    icon: 'ri-global-line',
  },
  {
    year: '2027',
    title: 'Vision: 1M+ Reached',
    desc: 'Our ambitious target — 1 million people reached through awareness campaigns, 500 patients supported, 500 healthcare workers trained, and 10 support groups established.',
    icon: 'ri-rocket-line',
    isFuture: true,
  },
];

export default function JourneyTimeline() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B]">Our Journey</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-4">
          From Vision to <span className="text-[#7B2D8B]">Impact</span>
        </h2>
        <p className="text-gray-500 text-center max-w-xl mx-auto mb-16 leading-relaxed">
          Every milestone is a testament to the communities we serve and the lives we are committed to transforming.
        </p>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-[#7B2D8B] via-[#C084FC] to-[#7B2D8B]/20 hidden md:block"></div>

          <div className="space-y-12">
            {milestones.map((m, i) => (
              <div
                key={`${m.year}-${m.title}`}
                className={`relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-0 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Content card */}
                <div className={`w-full md:w-[calc(50%-40px)] ${i % 2 === 0 ? 'md:pr-10 md:text-right' : 'md:pl-10'}`}>
                  <div className={`inline-block rounded-2xl p-6 border transition-all duration-200 hover:-translate-y-1 ${
                    m.isFuture
                      ? 'bg-[#7B2D8B]/5 border-[#7B2D8B]/30 border-dashed'
                      : 'bg-[#FAF7FC] border-purple-100'
                  }`}>
                    <div className={`flex items-center gap-3 mb-3 ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                      <span className={`text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full ${
                        m.isFuture ? 'bg-[#7B2D8B]/20 text-[#C084FC]' : 'bg-[#7B2D8B]/10 text-[#7B2D8B]'
                      }`}>
                        {m.year}
                      </span>
                      {m.isFuture && (
                        <span className="text-xs text-[#C084FC] font-medium italic">Target</span>
                      )}
                    </div>
                    <h3 className="font-bold text-gray-900 text-base mb-2">{m.title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
                  </div>
                </div>

                {/* Center dot */}
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-10 h-10 items-center justify-center rounded-full bg-[#7B2D8B] border-4 border-white z-10">
                  <i className={`${m.icon} text-white text-sm`}></i>
                </div>

                {/* Mobile dot */}
                <div className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-[#7B2D8B] border-4 border-white shrink-0">
                  <i className={`${m.icon} text-white text-sm`}></i>
                </div>

                {/* Empty side */}
                <div className="hidden md:block w-[calc(50%-40px)]"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
